// extracted by mini-css-extract-plugin
export default {"paginator":"InventoryList_paginator__y9a5p","tableActions":"InventoryList_tableActions__65Tkh"};